/**
 * Portrait FOV correction (spec 0029). three.js `fov` is VERTICAL: at a
 * portrait aspect (~0.46) a fixed vertical 90° collapses the horizontal view
 * to ~49° — tunnel vision that hides the ramps. Below square aspect we hold
 * the horizontal FOV the setting implies at aspect 1 and let the vertical
 * grow (clamped). At aspect ≥ 1 (any landscape/desktop) the input is returned
 * unchanged, so desktop behavior is identical by construction.
 */
export function effectiveFov(baseFovDeg: number, aspect: number, maxDeg = 130): number {
  if (aspect >= 1 || aspect <= 0) {
    return baseFovDeg;
  }
  const halfVertical = Math.atan(Math.tan((baseFovDeg * Math.PI) / 360) / aspect);
  return Math.min(maxDeg, (halfVertical * 360) / Math.PI);
}
